module.exports = __webpack_public_path__ + "img/uic-college.6fd9da70.png";